module.exports = __webpack_public_path__ + "img/method-man-left.95b0039b.png";